module.exports = __webpack_public_path__ + "img/photo.0e958194.png";